import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RestaurantIcon(props: IconProps) {
    return <Icon {...props} iconKey={"restaurant"}/>
}
